import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import Command from '@/assets/js/command.js';
import { routerJump } from '@/assets/js/utils.js';
export default {
  props: {
    changeTab: Boolean,
    type: String,
    conferenceMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      joinLink: state => {
        var _state$config$urlInfo;
        return (_state$config$urlInfo = state.config.urlInfo) === null || _state$config$urlInfo === void 0 ? void 0 : _state$config$urlInfo.joinLink;
      }
    }),
    returnNumber() {
      if (this.globalControlInfoTips.edit) {
        let selectNumber = 0;
        this.kioskPartyList.forEach(item => {
          if (item.checked && (!item.belongToGlobalControl || item.belongToGlobalControl == 2)) {
            selectNumber++;
          }
        });
        return selectNumber;
      } else {
        return this.selectPartyList.length;
      }
    }
  },
  data() {
    var _JSON$parse;
    return {
      deleteInfo: {
        item: '',
        index: ''
      },
      sortDirection: '',
      sortValue: '',
      sortList: [{
        label: 'Date',
        value: 'createTime',
        order: 'desc',
        key: 0
      }, {
        label: 'Name',
        value: 'title',
        order: 'asc',
        key: 1
      }, {
        label: 'Global Control',
        value: 'global',
        order: 'global',
        key: 2
      }],
      modeList: [{
        label: 'kiosk',
        value: 'Kiosk'
      }],
      cancel: {
        party: null,
        group: null
      },
      mettingList: [],
      selectPartyCode: '',
      createName: {
        kiosk: 'Start a kiosk mode'
      },
      selectPartyList: [],
      timer: null,
      partyNum: 3,
      env: handleLocalStorage('get', 'partylineConfig') ? (_JSON$parse = JSON.parse(handleLocalStorage('get', 'partylineConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiEnv : '',
      partyPageInfo: {
        pageNum: 1,
        pageSize: 20,
        hasNextPage: false
      },
      partyListLoading: false,
      removeInfoTips: {
        title: 'arenaMode.deleteParty',
        content: '<div class="end">Are you sure you want to delete this party？</p></div>',
        cancel: 'commonFunction.cancel',
        save: 'tagName.del',
        show: false,
        class: 'delPartyDialog'
      },
      globalControlInfoTips: {
        show: false,
        title: 'kioskHost.addToGlobalControl',
        cancel: 'commonFunction.cancel',
        save: 'Movepips.save',
        edit: false
      },
      globalName: '',
      gcList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tabPosition: 'left',
      kioskPartyList: [],
      showSearchInput: false,
      partyMode: 'Kiosk',
      currentGlobalControlId: '',
      showEmptyName: false
    };
  },
  created() {
    if (this.State.hasLogin) {
      this.State.partyCode = this.$route.query.id || '';
      this.sortDirection = '';
      this.sortValue = '';
      this.State.newPageLoading = true;
      this.getGlobalControlList('created');
    }
    Bus.$on('setPartyTitle', result => {
      this.mettingList.forEach((v, index) => {
        if (result.partyCode == v.code) {
          this.$set(this.mettingList, index, {
            ...v,
            title: result.title
          });
        }
      });
    });
    Bus.$on('endParty', val => {
      this.mettingList.forEach((v, index) => {
        if (v.code == val.partyCode) {
          v.lockName = false;
          this.$set(this.mettingList, index, v);
        }
      });
    });
    Bus.$on('partyOnlineStatus', val => {
      Object.keys(val).forEach(partyCode => {
        this.$set(this.State.parOnlineInfo, partyCode, val[partyCode].onlineRtilCodes);
      });
    });
    Bus.$on('showAddDialog', () => {
      // if (this.partyMode == 'Kiosk') {
      this.getKioskPartyList();
      // }
      this.selectPartyList = [];
      this.globalControlInfoTips.show = true;
      this.globalControlInfoTips.edit = true;
      this.globalName = this.State.currentPartyInfo.name;
    });
  },
  methods: {
    blurName() {
      if (!this.globalName) {
        this.showEmptyName = true;
      } else {
        this.showEmptyName = false;
      }
    },
    returnDisabled(item) {
      if (this.globalControlInfoTips.edit) {
        if (item.belongToGlobalControl == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (item.belongToGlobalControl) {
          return true;
        } else {
          return false;
        }
      }
    },
    returnClass(item) {
      let _str = '';
      if (this.globalControlInfoTips.edit) {
        if (item.belongToGlobalControl != 1 && item.checked) {
          _str = 'select';
        }
      } else {
        if (!item.belongToGlobalControl && item.checked) {
          _str = 'select';
        }
      }
      return _str;
    },
    getKioskPartyList() {
      const params = {
        globalControlId: this.State.globalControlId,
        pageSize: 100,
        pageNum: 1,
        sortField: '',
        sortDirection: ''
      };
      this.axios.post('/partyline-backend/kiosk/page', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          res.data.result.list.forEach(item => {
            if (item.belongToGlobalControl == 1 || item.belongToGlobalControl == 2) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          });
          this.kioskPartyList = res.data.result.list;
        }
      });
    },
    appendParty() {
      const array = [];
      this.kioskPartyList.forEach(item => {
        if (item.checked) {
          array.push(item.partyCode + '');
        }
      });
      const params = {
        globalControlId: this.State.currentPartyInfo.globalControlId,
        partyCodes: array
      };
      this.axios.post('/partyline-backend/globalControl/append', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.gcList.forEach(async (item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == this.State.currentPartyInfo.globalControlId) {
              item.partyCount = array.length;
              Bus.$emit('updateTableList', {
                type: 'add'
              });
              item.children = await this.getCurrentGCParty({
                globalControlId: this.State.currentPartyInfo.globalControlId
              }, 'init');
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    changeParty(item) {
      this.State.globalControlId = item.globalControlId;
      if (this.currentGlobalControlId != item.globalControlId) {
        this.currentGlobalControlId = item.globalControlId;
        this.State.currentPartyInfo = {};
        this.getGlobalControlInfo(item);
      }
    },
    async getGlobalControlInfo(item) {
      if (!item.globalControlId) return;
      await this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId: item.globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          if (result.mainWindowSetting) {
            result.mainWindowSetting.vfbResolution = result.mainWindowSetting.resolution;
            result.mainWindowSetting.vfbFrameRate = result.mainWindowSetting.frameRate;
            result.mainWindowSetting.vfbBitrate = result.mainWindowSetting.bitrate;
            result.mainWindowSetting.volume = result.mainWindowSetting.volume;
          }
          this.State.currentPartyInfo = {
            ...result,
            status: {},
            code: item.globalControlId,
            globalControlId: item.globalControlId
          };
          Bus.$emit('changePartyAddress', {
            currentId: item.globalControlId,
            lastId: '',
            init: 'initAside',
            title: item.name,
            id: item.globalControlId
          });
          Bus.$emit('initOperateData', result.mainWindowSetting);
        }
      });
    },
    // 用来保存要添加的 party
    savePartyInfo(val, item) {
      if (val) {
        item.checked = true;
        this.selectPartyList.push(item);
      } else {
        item.checked = false;
        this.selectPartyList.forEach((item1, index) => {
          if (item.partyCode == item1.partyCode) {
            this.selectPartyList.splice(index, 1);
          }
        });
      }
    },
    saveControl() {
      if (!this.globalName) {
        this.showEmptyName = true;
        return;
      }
      if (this.globalControlInfoTips.edit) {
        this.globalControlInfoTips.show = false;
        this.updateGlobalControl();
      } else {
        this.globalControlInfoTips.show = false;
        this.createGroup();
      }
    },
    updateGlobalControl() {
      const addParty = [];
      const removeParty = [];
      const selectPartyList = [];
      this.selectPartyList.forEach(item => {
        selectPartyList.push(item.partyCode);
      });
      this.kioskPartyList.forEach(item => {
        if (!item.belongToGlobalControl && selectPartyList.includes(item.partyCode)) {
          addParty.push(item.partyCode);
        }
        if (item.belongToGlobalControl == 2 && item.checked == false) {
          removeParty.push(item.partyCode);
        }
      });
      const params = {
        id: this.State.globalControlId,
        name: this.globalName,
        appendPartyCodes: addParty,
        removePartyCodes: removeParty
      };
      this.axios.post('/partyline-backend/globalControl/update', params).then(async res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.selectPartyList = [];
          this.$message.success(this.$t('mainWindow.success'));
          const partyList = await this.getPartyPage();
          this.gcList.forEach((item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == this.State.globalControlId) {
              item.children = partyList;
              item.title = this.globalName;
              item.label = this.globalName;
              item.partyCount = partyList.length;
              this.State.currentPartyInfo.name = this.globalName;
            }
          });
          Bus.$emit('changeTitle', this.globalName);
          Bus.$emit('updateTableList', {
            type: 'add'
          });
        }
      });
    },
    async getPartyPage() {
      let array = [];
      this.partyListLoading = true;
      await this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId: this.State.globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          array = res.data.result.pageInfoVo.list;
          array.forEach(item => {
            item.globalControlId = this.State.globalControlId;
            item.id = item.partyCode;
            item.editName = item.name;
          });
        }
        this.partyListLoading = false;
      });
      return array;
    },
    // 创建 globalControl
    createGroup() {
      const array = [];
      this.selectPartyList.forEach(item => {
        array.push(item.partyCode);
      });
      const params = {
        name: this.globalName,
        partyCodes: array
      };
      this.axios.post('/partyline-backend/globalControl/create', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.selectPartyList = [];
          this.$message.success(this.$t('mainWindow.success'));
          this.getGlobalControlList();
          Bus.$emit('setDefault');
        }
      });
    },
    // 查询 Global Control list
    getGlobalControlList(created) {
      if (!created) this.partyListLoading = true;
      this.axios.post('/partyline-backend/globalControl/page', {
        pageNum: 1,
        pageSize: 100
      }).then(async res => {
        if (!res) return;
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          const array = [];
          result.list.forEach((item, index) => {
            const obj = Object.assign({}, item);
            obj.label = item.name;
            obj.index = index + 1;
            obj.edit = false;
            obj.id = item.globalControlId;
            obj.editName = '';
            obj.title = item.name;
            // 先创建假数据后面在用真数据覆盖
            if (item.partyCount) {
              obj.children = [{
                name: 'Test',
                createTime: ''
              }];
            } else {
              obj.children = [];
            }
            array.push(obj);
          });
          if (result.list.length > 0) {
            const list = await this.getCurrentGCParty(result.list[0], 'init');
            list.forEach((item1, index) => {
              item1.visible = false;
              item1.edit = false;
              item1.redTip = false;
              item1.redMessage = '';
              item1.index = index;
              item1.editName = '';
              item1.id = item1.partyCode;
              item1.globalControlId = array[0].globalControlId;
            });
            array[0].children = list;
            this.State.globalControlId = array[0].globalControlId;
            this.currentGlobalControlId = array[0].globalControlId;
            handleLocalStorage('set', 'partyInfo', {
              code: array[0].globalControlId
            });
          } else {
            this.State.globalControlId = '';
          }
          this.gcList = array;
          if (result.list.length < 1) {
            this.partyListLoading = false;
          }
        } else {
          this.partyListLoading = false;
        }
        if (created) {
          this.State.newPageLoading = false;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    // 获取当前 GC 下的子 party
    async getCurrentGCParty(item, type) {
      this.State.globalControlId = item.globalControlId;
      let array = [];
      await this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId: item.globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          this.State.isTag = result.tag;
          if (this.State.isTag == 1) {
            this.State.soureTagType = 'Tag';
          }
          array = res.data.result.pageInfoVo.list;
          array.forEach((item, index) => {
            item.editName = item.name;
            item.globalControlId = this.State.globalControlId;
            item.id = item.partyCode;
            item.visible = false;
            item.edit = false;
            item.redTip = false;
            item.redMessage = '';
            item.index = index;
          });
          if (type != 'init') {
            item.children = array;
          }
          if (result.mainWindowSetting) {
            result.mainWindowSetting.vfbResolution = result.mainWindowSetting.resolution;
            result.mainWindowSetting.vfbFrameRate = result.mainWindowSetting.frameRate;
            result.mainWindowSetting.vfbBitrate = result.mainWindowSetting.bitrate;
            result.mainWindowSetting.volume = result.mainWindowSetting.volume;
          }
          this.State.currentPartyInfo = {
            ...result,
            status: {},
            code: item.globalControlId,
            globalControlId: item.globalControlId
          };
          Bus.$emit('changePartyAddress', {
            currentId: item.globalControlId,
            lastId: '',
            init: 'initAside',
            title: item.name,
            id: item.globalControlId
          });
          Bus.$emit('initOperateData', result.mainWindowSetting);
        }
        this.partyListLoading = false;
      });
      return array;
    },
    returnTitleText(node, data) {
      let _str = '';
      if ((node === null || node === void 0 ? void 0 : node.level) === 1) {
        _str = node.label;
      } else {
        if (data.name) {
          _str = data.name;
        } else {
          _str = new Date(data.createTime).toLocaleDateString() + '   ' + new Date(data.createTime).toLocaleTimeString();
        }
      }
      return _str;
    },
    returnContent(node, data) {
      let _str = '';
      if ((node === null || node === void 0 ? void 0 : node.level) === 1) {
        _str = this.$t('kioskHost.partySelect') + data.partyCount;
      } else {
        _str = this.$t('common.code') + ': ' + this.$options.filters.returnStrByInfo(data.partyCode);
      }
      return _str;
    },
    hideGlobalPopup(item, index) {
      item.visible = false;
    },
    copyGlobalParty(item) {
      const domain = window.location.host;
      return 'https://' + domain + '/partyline?join_id=' + item.partyCode + `${this.env ? '&env=' + this.env : ''}`;
    },
    deleteGlobalParty(info) {
      this.axios.post('/partyline-backend/globalControl/delete', {
        globalControlPartyId: info.globalControlPartyId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.gcList.forEach((item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == info.globalControlId) {
              item.partyCount--;
              item.children.forEach((item1, index) => {
                if (item1.partyCode == info.partyCode) {
                  item.children.splice(index, 1);
                  Bus.$emit('updateTableList', {
                    type: 'delete',
                    index
                  });
                }
              });
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    renameGlobal(node, data, type) {
      const obj = JSON.parse(JSON.stringify(data)); // copy一份避免重写被原来的值给覆盖
      data.edit = type === 'blur' ? false : !obj.edit;
      data.editName = obj.title || obj.name || new Date(obj.createTime).toLocaleDateString() + '   ' + new Date(obj.createTime).toLocaleTimeString();
      obj.redTip = false;
      obj.redMessage = '';
      data.visible = false;
      if (!data.edit) return;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        if ((node === null || node === void 0 ? void 0 : node.level) === 1) {
          this.$refs[`input${data.globalControlId}`].$refs.input.focus();
          this.$refs[`input${data.globalControlId}`].$refs.input.select();
        } else {
          this.$refs[`input${data.partyCode}`].$refs.input.focus();
          this.$refs[`input${data.partyCode}`].$refs.input.select();
        }
      });
    },
    deleteGlobal(data) {
      this.axios.delete(`/partyline-backend/globalControl/${data.globalControlId}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.gcList.forEach((item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == data.globalControlId) {
              this.State.pageSerBusRequestWs[item.globalControlId] && this.State.pageSerBusRequestWs[item.globalControlId].close();
              this.gcList.splice(index, 1);
            }
          });
          this.getGlobalControlList();
          Bus.$emit('updateTableList', {
            type: 'delete'
          });
          Bus.$emit('changePartyAddress', {
            currentId: '',
            lastId: '',
            init: 'initAside',
            title: '',
            id: ''
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    saveGlobalName(data, node) {
      if ((node === null || node === void 0 ? void 0 : node.level) == 1) {
        this.axios.post('/partyline-backend/globalControl/rename', {
          globalControlId: data.globalControlId,
          name: data.editName
        }).then(res => {
          const {
            errorCode
          } = res.data;
          if (errorCode === '0x0') {
            data.label = data.editName;
            data.title = data.editName;
            data.name = data.editName;
            data.edit = false;
            this.State.currentPartyInfo.name = data.editName;
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
            Bus.$emit('changeTitle', data.editName);
          }
        });
      } else {
        this.axios.post('/partyline-backend/kiosk/updateTitle', {
          id: data.partyId,
          title: data.editName,
          _partyCode: data.partyCode
        }).then(res => {
          if (res.data.errorCode === '0x0') {
            data.label = data.editName;
            data.title = data.editName;
            data.name = data.editName;
            data.edit = false;
            Bus.$emit('changePartyName', {
              partyCode: data.partyCode,
              name: data.editName
            });
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
          }
        });
      }
    },
    removeParty(info) {
      this.axios.post('/partyline-backend/globalControl/remove', {
        globalControlPartyId: info.globalControlPartyId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.gcList.forEach((item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == info.globalControlId) {
              item.partyCount--;
              item.children.forEach((item1, index) => {
                if (item1.partyCode == info.partyCode) {
                  item.children.splice(index, 1);
                  Bus.$emit('updateTableList', {
                    type: 'remove',
                    index
                  });
                }
              });
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    // Global Control 相关方法结束

    showParticipantsList(item) {
      this.$emit('showParticipantsList', item);
    },
    changeSort(value) {
      if (value === 'global') {
        if (this.$route.name.includes('controlParty')) {
          this.getGlobalControlList();
          return;
        } else {
          routerJump('controlParty');
          return;
        }
      }
      this.sortList.forEach(v => {
        if (v.value == value) {
          this.sortDirection = v.order;
        }
      });
      this.partyListLoading = false;
      this.partyPageInfo.pageNum = 1;
    },
    lockName(item) {
      Command.fn({
        partyCode: item.code,
        module: item.lockName ? 'unlockName' : 'lockName'
      }).then(data => {
        if (data.errorCode === '0x0') {
          this.$set(item, 'lockName', !item.lockName);
        }
      });
    },
    setCopy(item) {
      Command.fn({
        partyCode: item.code,
        module: item.partyBasicStatus.hasCopy ? 'cancelCopyButton' : 'setCopyButton'
      }).then(data => {
        if (data.errorCode === '0x0') {
          let message = this.$t('commonFunction.showInviteButtonTips');
          if (item.partyBasicStatus.hasCopy) {
            message = this.$t('commonFunction.hideInviteButtonTips');
          }
          this.$set(item.partyBasicStatus, 'hasCopy', !item.partyBasicStatus.hasCopy);
          this.$message.success(message);
        }
      });
    },
    rename(index, type) {
      const obj = JSON.parse(JSON.stringify(this.mettingList[index])); // copy一份避免重写被原来的值给覆盖
      obj.edit = type === 'blur' ? false : !obj.edit;
      obj.editName = obj.title || new Date(obj.startPartyTime).toLocaleDateString() + '   ' + new Date(obj.startPartyTime).toLocaleTimeString();
      obj.redTip = false;
      obj.redMessage = '';
      this.$set(this.mettingList, index, obj);
      if (!obj.edit) return;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        this.$refs[`input${index}`][0].$refs.input.focus();
        this.$refs[`input${index}`][0].$refs.input.select();
      });
      this.hidePopup(obj, index);
    },
    saveName(index) {
      const obj = this.mettingList[index];
      if (!obj.editName) {
        obj.redTip = false;
        obj.edit = !obj.edit;
        this.$set(this.mettingList, index, obj);
        return;
      }
      // 成功
      this.axios.post('/partyline-backend/kiosk/updateTitle', {
        id: obj.id,
        title: obj.editName
      }, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('copy.rename'));
          obj.title = obj.editName;
          obj.redTip = false;
          obj.edit = !obj.edit;
        } else {
          // 失败
          obj.redTip = true;
          obj.redMessage = res.data.errorInfo;
        }
        this.$set(this.mettingList, index, obj);
      }).catch(() => {
        // 失败
        obj.redTip = true;
        this.$set(this.mettingList, index, obj);
      });
    },
    loadNextPage(init) {
      let flag = true;
      if (this.partyListLoading || !init && !this.partyPageInfo.hasNextPage) {
        flag = false;
      }
      return flag;
    },
    hidePopup(item, index) {
      item.visible = false;
      this.$set(this.mettingList, index, item);
    },
    // 创建一个会议
    async createMeeting() {
      this.selectPartyList = [];
      this.globalControlInfoTips.show = true;
      this.globalControlInfoTips.edit = false;
      // if (this.partyMode == 'Kiosk') {
      this.getKioskPartyList();
      // }
    },

    // 检查已登入后开始创建
    async createParty(init) {
      const params = {
        title: ''
      };
      await this.axios.post('/partyline-backend/globalControl/create', params).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!init) {
            this.$message({
              type: 'success',
              message: this.$t('startNewParty.createSuccessful')
            });
          }
          // 获取正在进行中的会议列表
          this.partyPageInfo.pageNum = 1;
          this.globalName = '';
        } else {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        }
      });
    },
    copyParty(item) {
      const domain = window.location.host;
      return this.$t('addWords.copyLinkTips') + 'https://' + domain + '/partyline?join_id=' + item.code + `${this.env ? '&env=' + this.env : ''}` + '\n\n' + 'Party ID: ' + this.$options.filters.returnStrByInfo(item.code);
    },
    deleteParty(item, node) {
      item.visible = false;
      item.globalControlId = node.parent.data.globalControlId;
      this.deleteInfo.item = item;
      this.removeInfoTips.content = `<div class="end">${this.$t('addWords.sureDelParty')}</div>`;
      this.removeInfoTips.show = true;
    },
    onCopy(item) {
      this.$message({
        message: this.$t('copy.onCopy'),
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: this.$t('copy.onError'),
        type: 'error'
      });
    },
    onSureDeleteParty(item) {
      if (this.timer) clearTimeout(this.timer);
      // 为了 Global Control 删除特殊添加
      // 如果有则认为是 Global Control 里面的删除
      if (item.globalControlPartyId) {
        this.deleteGlobalParty(item);
        return;
      }
      this.timer = setTimeout(() => {
        this.axios.delete(`/partyline-backend/kiosk/${item.id}`).then(res => {
          if (res.data.errorCode === '0x0') {
            this.$message({
              message: this.$t('deleteParty.delS'),
              type: 'success'
            });
            item.visible = false;
            if (this.partyPageInfo.pageNum == 1 && this.partyPageInfo.hasNextPage) {} else {
              this.mettingList.splice(index, 1);
            }
            const partyCode = this.mettingList[0] ? this.mettingList[0].code : '';
            const layout = this.mettingList[0] ? this.mettingList[0].layout : '';
            const colunm = this.mettingList[0] ? this.mettingList[0].column : '';
            const layoutName = this.mettingList[0] ? this.mettingList[0].layoutName : '';
            if (this.selectPartyCode == item.code) {
              this.State.currentPartyInfo = this.mettingList[0];
              routerJump(this.type, {
                id: partyCode
              });
              Bus.$emit('changePartyAddress', {
                currentId: partyCode,
                lastId: item.id
              });
              this.selectPartyCode = partyCode;
              this.State.partyCode = partyCode;
              this.State.groupLayout = {
                layout: layout,
                colunm,
                layoutName
              };
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.errorInfo
            });
          }
        });
      }, 200);
    }
  }
};